import { render, staticRenderFns } from "./ManageStructures.vue?vue&type=template&id=4a8e08ce"
import script from "./ManageStructures.vue?vue&type=script&lang=js"
export * from "./ManageStructures.vue?vue&type=script&lang=js"
import style0 from "./ManageStructures.vue?vue&type=style&index=0&id=4a8e08ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports